export default __webpack_public_path__ + "352e4af271f60cc7c243e731247a7152.png";